export class QuickBuyVariantSelector extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.showModal = this.showModal.bind(this)
    this.variantChanged = this.variantChanged.bind(this)
    this.addToCart = this.addToCart.bind(this)

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
  }

  setupListeners () {
    this.externalEls?.trigger?.elements?.forEach((button) => {
      if (button.dataset.productId == this.dataset.productId) {
        button.addEventListener('click', () => {
          this.showModal(true)
        })
      }
    })

    this.els?.close?.element.addEventListener('click', () => {
      this.showModal(false)
    })

    this.els?.option?.elements?.forEach((button) => {
      button.addEventListener('click', (event) => {
        const variantId = event.currentTarget.getAttribute('data-variant-id')
        this.variantChanged(variantId, event.currentTarget)
      })
    })

    this.els.submit.element.addEventListener('click', () => {
      this.addToCart()
    })
  }

  showModal (show) {
    const modal = this
    if (!modal) return

    if (show) {
      modal.classList.add('prd-QuickBuy-active')
    } else {
      modal.classList.remove('prd-QuickBuy-active')
    }
  }

  variantChanged (variantId, button) {
    this.els.option.elements.forEach((btn) => {
      btn.classList.remove('prd-QuickBuySelector_Option-active')
    })

    button.classList.add('prd-QuickBuySelector_Option-active')

    this.els.variant.element.value = variantId

    this.els.submit.element.removeAttribute('disabled')
  }

  addToCart () {
    const form = this.els.form.element
    const atcButton = this.els.submit.element

    atcButton.textContent = atcButton.dataset.addingToCartText

    const formData = new FormData(form)

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
      },
    })
      .then(response => response.json())
      .then((response) => {
        atcButton.textContent = atcButton.dataset.addedToCartText

        setTimeout(() => {
          this.showModal(false)
          atcButton.textContent = atcButton.dataset.productAddToCart
        }, 1000)

        const cartDrawer = document.querySelector('cart-drawer')
        const cartDrawerEmptyState = cartDrawer.querySelector('.drawer__inner-empty')

        if (cartDrawerEmptyState) {
          cartDrawerEmptyState.style.display = 'none'
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        })

        if (this.cart && response) {
          this.cart.renderContents(response)
          this.updateCartCount()
        }
      })
      .catch(error => {
        atcButton.textContent = 'Sorry, something went wrong.'
        console.error('Error:', error)
      })
  }

  async updateCartCount () {
    try {
      // Fetch updated cart data
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`)
      const cart = await cartResponse.json()

      // Calculate cart count excluding child/bundled items
      let cartCount = 0
      if (cart.items && Array.isArray(cart.items)) {
        for (const item of cart.items) {
          // Skip items that have a parent (bundled/child items)
          if (!item.parent_relationship?.parent_key) {
            cartCount += item.quantity
          }
        }
      } else {
        // Fallback to item_count if items array not available
        cartCount = cart.item_count
      }

      // Update cart count
      const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count], .cart-count-bubble')
      cartCountElements.forEach(element => {
        element.textContent = cartCount
        if (cartCount > 0) {
          element.style.display = 'flex'
        }
      })

      const drawerCartCount = document.querySelector('.drawer__cart-count')
      if (drawerCartCount) {
        if (cartCount > 0) {
          drawerCartCount.textContent = cartCount + drawerCartCount.dataset.cartCountTextOne
        }
        if (cartCount > 1) {
          drawerCartCount.textContent = cartCount + drawerCartCount.dataset.cartCountTextMultiple
        }
      }
    } catch (error) {
      console.error('Error updating cart count:', error)
    }
  }
}

if (!customElements.get('quick-buy-variant-selector')) {
  customElements.define('quick-buy-variant-selector', QuickBuyVariantSelector)
}
